import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

export const getThreadStorageKey = (
  code: assistantPageCodeEnum,
  propertyId?: string
) => `chatkit_thread_${code}${propertyId ? `_${propertyId}` : ""}`;
